import { useTranslation } from 'react-i18next';
import Page from '../../../components/page';
import ActionHeader from '../../../components/actionHeader';
import { Container } from './styles';
import { Empty, Flex, Spin } from 'antd';
import { useSelector } from 'react-redux';
import {
  fetchMachines,
  selectIsFetchingMachine,
  selectMachines,
} from '../../../slices/machines';
import { useEffect } from 'react';
import { useAppDispatch } from '../../../store';
import MachineCard from '../../../components/machineCard';
import SearchInput from '../../../components/searchInput';
import {
  initDiagnoseConversation,
  setDiagnoseTemplateId,
} from '../../../slices/event';
import { useNavigate } from 'react-router';
import { Machine } from '../../../types';

const DiagnoseLanding = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const machines = useSelector(selectMachines);
  const isFetchingMachines = useSelector(selectIsFetchingMachine);

  const handleSearch = (searchText?: string) => {
    if (!isFetchingMachines) {
      dispatch(
        fetchMachines({
          search: searchText,
        })
      );
    }
  };

  useEffect(() => {
    dispatch(fetchMachines());
  }, []);

  const handleMachineClick = (machine: Machine) => {
    dispatch(setDiagnoseTemplateId(machine.templateID));
    dispatch(initDiagnoseConversation(machine.templateID));
    navigate(`machine/${machine.machineID}`);
  };

  return (
    <Page
      header={
        <ActionHeader
          title={t('diagnose_issue')}
          showBack={false}
          maxWidth={1248}
          endSlot={
            <SearchInput
              placeholder={t('search_for_machine')}
              onSearch={handleSearch}
            />
          }
        />
      }
    >
      <Container gap={16}>
        {isFetchingMachines ? (
          <Spin size="large" style={{ marginTop: 100 }} />
        ) : (
          <Flex vertical gap={8}>
            {machines.length ? (
              machines.map((machine) => (
                <MachineCard
                  key={machine.machineID}
                  data={machine}
                  onClick={() => handleMachineClick(machine)}
                />
              ))
            ) : (
              <Empty style={{ paddingTop: 80 }} />
            )}
          </Flex>
        )}
      </Container>
    </Page>
  );
};

export default DiagnoseLanding;
